import { Link } from "react-router-dom";
import { scrollToSection } from "./Navbar";

const nav = [
  { label: "Chi Siamo", href: "#chi-siamo" },
  { label: "Servizi", href: "#attivita" },
  { label: "Realizzazioni", href: "#realizzazioni" },
  { label: "Contatti", href: "#contatti" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-white border-t border-black/10">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5">
        <span className="text-xs text-[#1C1B1A]/50">© {new Date().getFullYear()} FKL S.r.l.s. — Viale Vif, 12 - 10040 Rivalta di Torino (TO) · P.I. 12481530017</span>
        <div className="flex items-center gap-8">
          {nav.map((l) => (
            <button
              key={l.href}
              data-testid={`footer-link-${l.href.slice(1)}`}
              onClick={() => scrollToSection(l.href)}
              className="hidden md:block whitespace-nowrap text-[11px] font-bold uppercase tracking-[0.18em] text-[#1C1B1A]/60 hover:text-[#E30613] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <Link data-testid="footer-admin-link" to="/admin" className="whitespace-nowrap text-[11px] font-bold uppercase tracking-[0.18em] text-[#1C1B1A]/40 hover:text-[#E30613] transition-colors duration-300">
            Area riservata
          </Link>
        </div>
      </div>
    </footer>
  );
}
